/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useFormik} from 'formik'
import React, { useEffect, useState } from 'react'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import * as Yup from 'yup'
import useAuth from '../../../../hooks/useAuth'
import {KTSVG} from '../../../../_metronic/helpers'
/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const intl = useIntl()
  const [showPassword, setShowPassword] = useState(false)
  const [isFormFocused, setIsFormFocused] = useState(false)

  const loginSchema = Yup.object().shape({
    username: Yup.string()
      .email(intl.formatMessage({id: 'FORM.ERROR.EMAIL.WRONG_FORMAT'}))
      .min(3, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MIN'}, {min: 3}))
      .max(50, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MAX'}, {max: 50}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
    password: Yup.string()
      .min(3, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MIN'}, {min: 3}))
      .max(50, intl.formatMessage({id: 'FORM.ERROR.SYMBOL.MAX'}, {max: 50}))
      .required(intl.formatMessage({id: 'FORM.ERROR.REQUIRED'})),
  })

  const initialValues = {
    username: '',
    password: '',
  }

  const {actionLoading, login} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      const {username, password} = values
      login({username, password}).then((res) => {
        const payload: any = res.payload
        if (payload.success) {
        } else {
          setStatus(payload.message)
        }
      })
    },
  })

  // Stunning attractive form styling
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = `
      /* Stunning Attractive Form */
      .modern-form {
        width: 100%;
        position: relative;
        z-index: 10;
      }

      .form-group {
        margin-bottom: 2rem;
        animation: slideInUp 0.8s ease forwards;
        opacity: 0;
        transform: translateY(30px);
      }

      .password-label-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 0.75rem;
        gap: 1rem;
      }

      .form-label {
        flex: 1;
        margin-bottom: 0;
      }

      .forgot-password-link {
        font-size: 0.875rem;
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        transition: all 0.3s ease;
        white-space: nowrap;
        flex-shrink: 0;
      }

      .forgot-password-link:hover {
        color: white;
        text-decoration: underline;
      }


      .form-group:nth-child(1) { animation-delay: 0.2s; }
      .form-group:nth-child(2) { animation-delay: 0.4s; }
      .form-group:nth-child(3) { animation-delay: 0.6s; }
      .form-group:nth-child(4) { animation-delay: 0.8s; }

      .form-label {
        display: block;
        margin-bottom: 0.75rem;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.95rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        transition: all 0.3s ease;
      }

      .password-label-container .form-label {
        margin-bottom: 0;
      }

      .form-control {
        width: 100%;
        padding: 1rem 1.5rem;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 12px;
        font-size: 1rem;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(10px);
        color: white;
        transition: all 0.3s ease;
        position: relative;
      }

      .form-control::placeholder {
        color: rgba(255, 255, 255, 0.6);
      }

      .form-control:focus {
        outline: none;
        border-color: rgba(255, 255, 255, 0.6);
        background: rgba(255, 255, 255, 0.25);
        box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
      }

      .form-control.error {
        border-color: #ff6b6b;
        box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
      }

      /* Stunning Button */
      .btn-primary {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 12px;
        padding: 1rem 2rem;
        font-weight: 600;
        font-size: 1rem;
        color: white;
        width: 100%;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .btn-primary::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.5s;
      }

      .btn-primary:hover::before {
        left: 100%;
      }

      .btn-primary:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
      }

      .btn-primary:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
      }

      /* Password Toggle */
      .password-toggle {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.2);
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 6px;
        transition: all 0.3s ease;
        color: white;
      }

      .password-toggle:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: translateY(-50%) scale(1.1);
      }

      /* Error Messages */
      .error-message {
        color: #ff6b6b;
        font-size: 0.875rem;
        margin-top: 0.5rem;
        animation: shake 0.5s ease;
      }

      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        25% { transform: translateX(-5px); }
        75% { transform: translateX(5px); }
      }

      /* Links */
      .auth-link {
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        font-weight: 500;
        transition: all 0.3s ease;
        position: relative;
      }

      .auth-link::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 0;
        height: 2px;
        background: white;
        transition: width 0.3s ease;
      }

      .auth-link:hover::after {
        width: 100%;
      }

      .auth-link:hover {
        color: white;
        transform: translateY(-1px);
      }

      /* Heading */
      .auth-heading {
        text-align: center;
        margin-bottom: 2.5rem;
        animation: slideInDown 0.8s ease forwards;
        opacity: 0;
        transform: translateY(-30px);
      }

      .auth-heading h1 {
        font-size: 2.5rem;
        font-weight: 700;
        color: white;
        margin-bottom: 0.75rem;
        text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
      }

      .auth-heading p {
        color: rgba(255, 255, 255, 0.8);
        font-size: 1.1rem;
        margin: 0;
      }

      @keyframes slideInDown {
        from {
          opacity: 0;
          transform: translateY(-30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      /* Alert */
      .alert {
        border-radius: 12px;
        border: none;
        padding: 1rem 1.5rem;
        margin-bottom: 2rem;
        animation: slideInDown 0.6s ease;
        background: rgba(255, 107, 107, 0.1);
        color: #ff6b6b;
        border-left: 4px solid #ff6b6b;
      }

      /* Responsive */
      @media (max-width: 768px) {
        .auth-heading h1 {
          font-size: 2rem;
        }
        
        .form-control {
          padding: 0.875rem 1.25rem;
        }
        
        .btn-primary {
          padding: 0.875rem 1.5rem;
        }

        .password-label-container {
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
        }

        .forgot-password-link {
          align-self: flex-end;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <div className='modern-form'>
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
        onFocus={() => setIsFormFocused(true)}
        onBlur={() => setIsFormFocused(false)}
    >
      {/* begin::Heading */}
        <div className='auth-heading'>
          <h1>{intl.formatMessage({id: 'AUTH.SIGN_IN'})}</h1>
          <p>
          {intl.formatMessage({id: 'MENU.NEW_HERE?'})}
          {` `}
            <Link to='/auth/registration' className='auth-link'>
            {intl.formatMessage({id: 'MENU.CREATE_AN_ACCOUNT'})}
          </Link>
          </p>
        </div>
        {/* end::Heading */}

      {formik.status && (
          <div className='alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}
        <div className='form-group'>
          <label className='form-label'>
          {intl.formatMessage({id: 'MENU.EMAIL'})}
        </label>
        <input
          placeholder={intl.formatMessage({id: 'MENU.EMAIL'})}
            {...formik.getFieldProps('username')}
          className={clsx(
              'form-control',
            {
                'error': formik.touched.username && formik.errors.username,
                'success': formik.touched.username && !formik.errors.username,
            }
          )}
          type='email'
          name='username'
          autoComplete='off'
        />
        {formik.touched.username && formik.errors.username && (
            <div className='error-message' role='alert'>
              {formik.errors.username}
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
        <div className='form-group'>
          <div className='password-label-container'>
            <label className='form-label'>
              {intl.formatMessage({id: 'MENU.PASSWORD'})}
            </label>
            <Link
              to='/auth/forgot-password'
            className='auth-link forgot-password-link'
            >
              {intl.formatMessage({id: 'MENU.FORGOT_PASSWORD'})}
            </Link>
          </div>
          <div className='position-relative'>
          <input
            type={showPassword ? 'text' : 'password'}
            autoComplete='off'
            placeholder={intl.formatMessage({id: 'MENU.PASSWORD'})}
            {...formik.getFieldProps('password')}
            className={clsx(
                'form-control',
                {
                  'error': formik.touched.password && formik.errors.password,
                  'success': formik.touched.password && !formik.errors.password,
              }
            )}
          />
            <button
              type='button'
              className='password-toggle'
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
            {showPassword ? (
                <KTSVG
                  path='/media/svg/stolen/Hidden.svg'
                  className='svg-icon-2x'
                />
              ) : (
                <KTSVG
                  path='/media/svg/stolen/Visible.svg'
                  className='svg-icon-2x' 
                />
            )}
            </button>
          </div>
        {formik.touched.password && formik.errors.password && (
            <div className='error-message' role='alert'>
                {formik.errors.password}
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
        <div className='form-group'>
        <button
          type='submit'
          id='kt_sign_in_submit'
            className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!actionLoading && (
            <span className='indicator-label'>{intl.formatMessage({id: 'AUTH.SIGN_IN'})}</span>
          )}
          {actionLoading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'AUTH.SIGN_IN'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>

    </div>
  )
}
